import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/shared/components/ui/card";
import t from "@/lang/lang";
import {
  Commitment,
  Relationship,
} from "@/services/backend/relationships/types/relationship";
import { ListRequest } from "@/services/backend/relationships/api/fulfillment_service";
import {
  FulfillmentsTable,
  FulfillmentsTableFilters,
} from "@/routes/customers/[customerId]/relationships/[relationshipId]/commitments/[commitmentId]/_components/fulfillments-table";
import { useState } from "react";
import { CreateFulfillmentDialog } from "@/services/backend/relationships/components/create-fulfillment-dialog";

export function FulfillmentCard({
  relationship,
  commitment,
}: {
  relationship: Relationship;
  commitment: Commitment;
}) {
  const [request, setRequest] = useState<ListRequest>({
    commitment: {
      active: true,
      values: [commitment.id],
    },
    limit: 10,
    offset: 0,
  });

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t("Arbeitsscheine")}</CardTitle>
        <CardDescription>
          {t(
            "Hier stehen die Arbeitsscheine welche zur Erfüllung der Sollstellung angelegt wurden.",
          )}
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="grid gap-2">
          <div className="flex items-center justify-between">
            <FulfillmentsTableFilters
              request={request}
              onRequestChange={setRequest}
            />
            <CreateFulfillmentDialog
              relationship={relationship}
              commitment={commitment}
            />
          </div>
          <FulfillmentsTable
            request={request}
            onRequestChange={setRequest}
            hideBorder
          />
        </div>
      </CardContent>
    </Card>
  );
}
